export default {
  setPagination(state, pagination) {
    state.pagination = pagination;
  },
  setInvoices(state, invoices) {
    state.invoices = invoices;
  }
};
